const StorageManagerConstants = {
  "CALLBACK_EMAIL_VERIFICATION_KEY": "callback_email_verification",
  "CALLBACK_RESET_PASSWORD_KEY": "callback_reset_password",
  "TENANT_EXPIRATION_DAYS": 5,
  "SITIO_ID_KEY": "origen_id",
  "MODO_ID_KEY": "modo"
}

export default StorageManagerConstants;